<template>
  <div>
    <Breadcrumbs
      :breadcrumbs="[
        { title: this.$t(`menu.${serviceSlug}`), disabled: true },
        { title: $t('evocall.history.title'), disabled: true }
      ]">

      <div slot="breadcrumbAfter" class="d-flex align-items-center">
        <Searchable class="mr-2" :querySearch.sync="querySearch" />
        <Filters
          :isActive="showFilters"
          :activeFilters="activeFilters"
          @toggle-filters="toggleFilters" />
      </div>
    </Breadcrumbs>

    <TableView
      ref="tableView"
      :clinicalServiceId="component.clinical_service_id"
      :service="component.service"
      :serviceSlug="serviceSlug"
      :showFilters.sync="showFilters"
      :querySearch="querySearch"
      @row-clicked="onRequestClicked"
      @filters-updated="onFiltersUpdated"
    />

  </div>
</template>
<script>
import TableView from './TableView'
import Filters from '@/components/common/Filters'
import Searchable from '@/components/common/Searchable'
import Breadcrumbs from '@/components/common/Breadcrumbs'
import IndexTablesMixin from '@/mixins/IndexTablesMixin'
import { TABLE_EVOCALL_HISTORY } from '@/local-storage/LocalStorageKeys'

const AppointmentDetailsInfoType = 300

export default {
  props: {
    component: {
      type: Object,
      required: true
    },
    serviceSlug: {
      type: String,
      required: true
    }
  },
  mixins: [
    IndexTablesMixin
  ],
  components: {
    Filters,
    TableView,
    Searchable,
    Breadcrumbs
  },
  data () {
    return {
      querySearch: '',
      showFilters: false,
      activeFilters: 0,
      localStorageKey: TABLE_EVOCALL_HISTORY
    }
  },

  methods: {
    onFiltersUpdated: function (activeFilters) {
      this.activeFilters = activeFilters
    },
    onRequestClicked: function ({ request }) {
      const authClinicalService = this.$store.state.services.find(s => s.id === request.service_id)
      if (authClinicalService && authClinicalService.user_permissions.some(permission => permission.info_type === AppointmentDetailsInfoType && (permission.entity_id === null || permission.entity_id === request.entity_id))) {
        this.$router.push({ name: `${this.serviceSlug}evocall/history/id`, params: { id: request.id } })
      }
    },
    toggleFilters: function () {
      this.showFilters = !this.showFilters
    }
  }
}
</script>
